module.exports = __webpack_public_path__ + "static/img/257.18016c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/news/257.png
// module id = X+LQ
// module chunks = 0